import { NgModule } from "@angular/core";
import { EmployeesComponent } from "src/app/pos-panel/components/employees/employees.component";
import { AddOrEditVenuesComponent } from "src/app/pos-panel/components/venues/addoreditvenues/addoreditvenues.component";
import { VenuesComponent } from "src/app/pos-panel/components/venues/venues.component";
import { PosRoutingModule } from "./pos-routing.module";
import { EditProfileComponent } from "../../pos-panel/components/edit-profile/edit-profile.component";
import { SharedModule } from "../shared/shared.module";
import { AddOrEditEmployeeComponent } from "src/app/pos-panel/components/employees/add-or-edit-employee/add-or-edit-employee.component";
import { DeleteEmployeeComponent } from "../../pos-panel/components/employees/delete-employee/delete-employee.component";
import { AssignVenuesComponent } from "../../pos-panel/components/employees/assign-venues/assign-venues.component";
import { DeleteVenueComponent } from "src/app/pos-panel/components/venues/delete-venue/delete-venue.component";
import { CategoriesComponent } from "src/app/pos-panel/components/categories/categories.component";
import { SubcategoriesComponent } from "src/app/pos-panel/components/subcategories/subcategories.component";
import { MenusComponent } from "src/app/pos-panel/components/menus/menus.component";
import { MenuItemsComponent } from "src/app/pos-panel/components/menu-items/menu-items.component";
import { AddOrEditCategoryComponent } from "src/app/pos-panel/components/categories/add-or-edit-category/add-or-edit-category.component";
import { DeleteCategoryComponent } from "src/app/pos-panel/components/categories/delete-category/delete-category.component";
import { ManagerEmployeesComponent } from "../../pos-panel/components/manager-employees/manager-employees.component";
import { AddOrEditManagerEmployeeComponent } from "../../pos-panel/components/manager-employees/add-or-edit-manager-employee/add-or-edit-manager-employee.component";
import { DeleteManagerEmployeeComponent } from "../../pos-panel/components/manager-employees/delete-manager-employee/delete-manager-employee.component";
import { AssignShiftComponent } from "../../pos-panel/components/manager-employees/assign-shift/assign-shift.component";
import { DashboardComponent } from "../../pos-panel/components/dashboard/dashboard.component";
import { DeleteSubcategoryComponent } from "src/app/pos-panel/components/subcategories/delete-subcategory/delete-subcategory.component";
import { AddOrEditSubcategoryComponent } from "src/app/pos-panel/components/subcategories/add-or-edit-subcategory/add-or-edit-subcategory.component";
import { AddOrEditMenuItemComponent } from "src/app/pos-panel/components/menu-items/add-or-edit-menu-item/add-or-edit-menu-item.component";
import { DeleteMenuItemComponent } from "src/app/pos-panel/components/menu-items/delete-menu-item/delete-menu-item.component";
import { DeleteMenuComponent } from "src/app/pos-panel/components/menus/delete-menu/delete-menu.component";
import { AddOrEditMenuComponent } from "src/app/pos-panel/components/menus/add-or-edit-menu/add-or-edit-menu.component";
import { CreateCapacityForVenuesComponent } from "src/app/pos-panel/components/venues/create-capacity-for-venues/create-capacity-for-venues.component";
import { ManagerMenusComponent } from "../../pos-panel/components/manager-menus/manager-menus.component";
import { AssignMenuToVenuesComponent } from "../../pos-panel/components/menus/assign-menu-to-venues/assign-menu-to-venues.component";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InventoryComponent } from "src/app/pos-panel/components/inventory-management/inventory/inventory.component";
import { AddIngredientItemComponent } from '../../pos-panel/components/menu-items/add-ingredient-item/add-ingredient-item/add-ingredient-item.component';
import { ManagerEmployeeOrdersComponent } from '../../pos-panel/components/manager-employee-orders/manager-employee-orders.component';
import { DivisionsComponent } from "../../pos-panel/components/venues/divisions/divisions.component";

import {
  AddOrEditDivisionComponent
} from "../../pos-panel/components/venues/divisions/add-or-edit-division/add-or-edit-division.component";
import {
  DeleteDivisionComponent
} from "../../pos-panel/components/venues/divisions/delete-division/delete-division.component";
import { MenuDetailsComponent } from "../../pos-panel/components/menus/menu-details/menu-details.component";
import {
  DivisionMenuDetailsComponent
} from "../../pos-panel/components/dashboard/division-menu-details/division-menu-details.component";
import { TaxRatesComponent } from "../../pos-panel/components/tax-rates/tax-rates.component";
import {
  AddOrEditTaxRateComponent
} from "../../pos-panel/components/tax-rates/add-or-edit-tax-rate/add-or-edit-tax-rate.component";
import {
  DeleteTaskRateComponent
} from "../../pos-panel/components/tax-rates/delete-task-rate/delete-task-rate.component";
import { SuppliersComponent } from "../../pos-panel/components/suppliers/suppliers.component";
import {
  SupplierOrderDetailsComponent
} from "../../pos-panel/components/suppliers/supplier-order-details/supplier-order-details.component";
import {
  DeleteGroupDialogComponent
} from "../../pos-panel/components/venues/create-capacity-for-venues/delete-group-dialog/delete-group-dialog.component";
import { InventoryDetailsComponent } from 'src/app/pos-panel/components/inventory-management/inventory-details/inventory-details.component';
import { NewPurchaseOrderComponent } from 'src/app/pos-panel/components/inventory-management/purchase-orders/new-purchase-order/new-purchase-order.component';
import { PurchaseOrderDetailsComponent } from 'src/app/pos-panel/components/inventory-management/purchase-orders/purchase-order-details/purchase-order-details.component';
import { PurchaseOrderReceiptComponent } from 'src/app/pos-panel/components/inventory-management/purchase-orders/purchase-order-receipt/purchase-order-receipt.component';
import { AddOrEditSupplierComponent } from "src/app/pos-panel/components/supplier/add-or-edit-supplier/add-or-edit-supplier.component";
import { AddOrEditInventoryComponent } from "src/app/pos-panel/components/inventory-management/inventory/add-or-edit-inventory/add-or-edit-inventory.component";
import { AddOrEditInventoryItemComponent } from "src/app/pos-panel/components/inventory-management/add-or-edit-inventory-item/add-or-edit-inventory-item.component";
import { ItemWriteOffComponent } from "src/app/pos-panel/components/inventory-management/item-write-off/item-write-off.component";
import { ItemRestockComponent } from "src/app/pos-panel/components/inventory-management/item-restock/item-restock.component";
import { ReceivedPurchaseOrderDetailsComponent } from "src/app/pos-panel/components/inventory-management/purchase-orders/received-purchase-order-details/received-purchase-order-details.component";
import { NewOutgoingTransferComponent } from "src/app/pos-panel/components/inventory-management/transfer/new-outgoing-transfer/new-outgoing-transfer.component";
import { OutgoingTransferDetailsComponent } from "src/app/pos-panel/components/inventory-management/transfer/outgoing-transfer-details/outgoing-transfer-details.component";
import { IncomingTransferDetailsComponent } from "src/app/pos-panel/components/inventory-management/transfer/incoming-transfer-details/incoming-transfer-details.component";
import { NewStockTakeComponent } from "src/app/pos-panel/components/inventory-management/stock-take/new-stock-take/new-stock-take.component";
import { StockTakeDetailsComponent } from "src/app/pos-panel/components/inventory-management/stock-take/stock-take-details/stock-take-details.component";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { MenuComponent } from "src/app/pos-panel/components/menu-management/menu/menu.component";
import { AddOrEditMenuCategoryComponent } from "src/app/pos-panel/components/menu-management/menu/add-or-edit-menu-category/add-or-edit-menu-category.component";
import { AddOrEditMenuSubcategoryComponent } from "src/app/pos-panel/components/menu-management/menu/add-or-edit-menu-subcategory/add-or-edit-menu-subcategory.component";
import { AddOrEditMenuItemComponentV2 } from "src/app/pos-panel/components/menu-management/menu/add-or-edit-menu-item/add-or-edit-menu-item.component";
import { MenuItemDetailsComponent } from "src/app/pos-panel/components/menu-management/menu/menu-item-details/menu-item-details.component";
import { StockTakeInputComponent } from "src/app/pos-panel/components/inventory-management/stock-take/stock-take-input/stock-take-input.component";
import { DivisionComponent } from "src/app/pos-panel/components/division/division.component";
import { AddOrEditDivisionComponentV2 } from "src/app/pos-panel/components/division/add-or-edit-division/add-or-edit-division.component";
import { SupplierComponent } from "src/app/pos-panel/components/supplier/supplier.component";
import { TaxRateComponent } from "src/app/pos-panel/components/tax-rate/tax-rate.component";
import { AddOrEditTaxRateComponentV2 } from "src/app/pos-panel/components/tax-rate/add-or-edit-tax-rate/add-or-edit-tax-rate.component";
import { TransferReceiptComponent } from "src/app/pos-panel/components/inventory-management/transfer/transfer-receipt/transfer-receipt.component";
import { GroupsComponent } from "src/app/pos-panel/components/groups-management/groups/groups.component";
import { NewGroupComponent } from "src/app/pos-panel/components/groups-management/new-group/new-group.component";
import { OrderDetailsComponent } from "src/app/pos-panel/components/orders-management/order-details/order-details.component";
import { BillsFilterComponent } from "src/app/pos-panel/components/orders-management/turnover-records/bills-filter/bills-filter.component";
import { TurnoverRecordsComponent } from "src/app/pos-panel/components/orders-management/turnover-records/turnover-records.component";
import { BillDetailsComponent } from "src/app/pos-panel/components/orders-management/bill-details/bill-details.component";
import { OrdersFilterComponent } from "src/app/pos-panel/components/orders-management/turnover-records/orders-filter/orders-filter.component";
import { PriceCalculationsValidator } from "src/app/pos-panel/components/inventory-management/item-restock/price-validator.directive";


@NgModule({
  declarations: [
    VenuesComponent,
    EmployeesComponent,
    AddOrEditVenuesComponent,
    DeleteVenueComponent,
    AddOrEditEmployeeComponent,
    EditProfileComponent,
    DeleteEmployeeComponent,
    AssignVenuesComponent,
    CategoriesComponent,
    SubcategoriesComponent,
    MenusComponent,
    MenuItemsComponent,
    AddOrEditCategoryComponent,
    DeleteCategoryComponent,
    ManagerEmployeesComponent,
    AddOrEditManagerEmployeeComponent,
    DeleteManagerEmployeeComponent,
    AssignShiftComponent,
    DashboardComponent,
    DeleteSubcategoryComponent,
    AddOrEditSubcategoryComponent,
    AddOrEditMenuItemComponent,
    DeleteMenuItemComponent,
    DeleteMenuComponent,
    AddOrEditMenuComponent,
    CreateCapacityForVenuesComponent,
    ManagerMenusComponent,
    AssignMenuToVenuesComponent,
    InventoryComponent,
    AddIngredientItemComponent,
    ManagerEmployeeOrdersComponent,
    OrderDetailsComponent,
    DivisionsComponent,
    AddOrEditDivisionComponent,
    DeleteDivisionComponent,
    MenuDetailsComponent,
    DivisionMenuDetailsComponent,
    TaxRatesComponent,
    AddOrEditTaxRateComponent,
    DeleteTaskRateComponent,
    SuppliersComponent,
    SupplierOrderDetailsComponent,
    DeleteGroupDialogComponent,
    AddOrEditInventoryComponent,
    InventoryDetailsComponent,
    NewPurchaseOrderComponent,
    PurchaseOrderDetailsComponent,
    PurchaseOrderReceiptComponent,
    AddOrEditSupplierComponent,
    AddOrEditInventoryItemComponent,
    ItemWriteOffComponent,
    ItemRestockComponent,
    ReceivedPurchaseOrderDetailsComponent,
    NewOutgoingTransferComponent,
    OutgoingTransferDetailsComponent,
    IncomingTransferDetailsComponent,
    NewStockTakeComponent,
    StockTakeDetailsComponent,
    MenuComponent,
    AddOrEditMenuCategoryComponent,
    AddOrEditMenuSubcategoryComponent,
    AddOrEditMenuItemComponentV2,
    MenuItemDetailsComponent,
    StockTakeInputComponent,
    DivisionComponent,
    AddOrEditDivisionComponentV2,
    SupplierComponent,
    TaxRateComponent,
    AddOrEditTaxRateComponentV2   ,
    TransferReceiptComponent,
    GroupsComponent,
    NewGroupComponent,
    OrderDetailsComponent,
    TurnoverRecordsComponent,
    BillDetailsComponent,
    OrdersFilterComponent,
    BillsFilterComponent
  ],
  imports: [
    PosRoutingModule,
    DragDropModule,
    SharedModule,
    ConfirmDialogModule,
    PriceCalculationsValidator
  ],
  exports: []
})

export class PosModule { }
